import React from 'react';
import errorSvg from '../../assets/svg/result-error.svg';
import { useStateContext } from '../../context/StateContext';
import Card from '../../components/Card';
import style from './payment-check.module.scss';

const PaymentCheck = () => {
    const { state } = useStateContext();
	const { pageSettings: { routePaymentPageDescription } } = state;
	return (
		<>
            <Card className={style.resultPaymentContainer}>
                <div className={style.paymentCheckInfo}>
                    <img src={errorSvg} alt='error' />
                    <label>{routePaymentPageDescription}</label>
                </div>
            </Card>
		</>
	);
};

export default PaymentCheck;
